// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#rootVM[data-v-25d3c9d2] {\n\twidth: 100%;\n\theight: 100vh;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n#rootVM i[data-v-25d3c9d2] {\n\tfont-size: 3em;\n\tmargin: auto;\n}\n", ""]);
// Exports
module.exports = exports;
